import { registerPlugin } from '@capacitor/core';

interface ILegacyImport {
  load(options: { brand: string; value: string }): Promise<{ value: string }>;
  setRead(options: { brand: string; value: string }): Promise<{ value: string }>;
}

export const LegacyImport = registerPlugin<ILegacyImport>('LegacyImport');
